import "./Booking.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ScheduleYourSession from "./sections/ScheduleYourSession";
import BookingFaq from "./sections/BookingFaq";
import SiteFooter from "@/reusable_sections/Footer";
export default function BookingPage() {
  return <div>
      <MainNavigation />
      <ScheduleYourSession />
      <BookingFaq />
      <SiteFooter />
    </div>;
}